export const AppPermissions = {
	// ─── campaigns ──────────────────────────────────────────────
	CanCreateCampaign:                'campaign.create',
	CanCreateCampaignForSubordinate:  'campaign.create.for-subordinate',
	CanViewOwnCampaigns:              'campaign.view.own',
	CanViewSubordinateCampaigns:      'campaign.view.subordinate',
	CanCancelOwnCampaign:             'campaign.cancel.own',
	CanActivateReservedCampaign:      'campaign.activate-reserved',
	CanSetTransactionCode:            'campaign.set-transaction-code',

	// ─── agency / child companies ───────────────────────────────
	CanCreateSubordinateCompany:      'company.create-subordinate',
	CanViewSubordinateCompanies:      'company.view.subordinate',
	CanUnlinkSubordinateCompany:      'company.unlink',

	// ─── places ────────────────────────────────────────────────
	CanCreatePlace:                   'place.create',
	CanUpdateOwnPlace:                'place.update.own',
	CanDeleteOwnPlace:                'place.delete.own',
	CanSubmitOwnPlace:                'place.submit.own',
	CanViewOwnPlaces:                 'place.view.own',

	// ─── screens ───────────────────────────────────────────────
	CanCreateScreen:                  'screen.create',
	CanUpdateOwnScreen:               'screen.update.own',
	CanDeleteOwnScreen:               'screen.delete.own',
	CanViewOwnScreens:                'screen.view.own',
	CanBindScreen:                    'screen.bind',
	CanUnbindScreen:                  'screen.unbind',
	CanSuspendScreen:                 'screen.suspend',
	CanUnsuspendScreen:               'screen.unsuspend',

	// ─── files ─────────────────────────────────────────────────
	CanUploadCampaignFile:            'file.upload.campaign',
	CanUploadAvatar:                  'file.upload.avatar',
	CanUploadScreenFile:              'file.upload.screen',
	CanUploadPlaceFile:               'file.upload.place',
	CanUploadKycFile:                 'file.upload.kyc',
	CanViewOwnFiles:                  'file.view.own',
	CanViewSubordinateFiles:          'file.view.subordinate',
	CanViewAssignedFiles:             'file.view.assigned',
	CanDeleteOwnFile:                 'file.delete.own',

	// ─── billing ───────────────────────────────────────────────
	CanCreatePayment:                 'payment.create',
	CanViewOwnPayments:               'payment.view.own',
	CanViewOwnTransfers:              'transfer.view.own',

	// ─── statistics ────────────────────────────────────────────
	CanViewOwnStatistics:             'statistics.view.own',
	CanViewSubordinateStatistics:     'statistics.view.subordinate',
	CanViewScreenOwnerStatistics:     'statistics.view.screen-owner',

	// ─── misc ──────────────────────────────────────────────────
	CanApplyPromoCode:                'promo-code.apply',
} as const

export type Permission = typeof AppPermissions[keyof typeof AppPermissions]
